import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ProductsRootScreenParamList } from "../../../../types";
import {
  RootDrawerToggle,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { ProductsListScreen } from "../ProductsListScreen";
import { CreateProductRootScreen } from "../CreateProductRootScreen";
import { EditProductRootScreen } from "../EditProductRootScreen";
import { ProductFormActionsContext } from "../../components/ProductForm/context";
import { ProductListFilterRootScreen } from "../ProductListFilterRootScreen";
import { useListFilter } from "../../../../utilities/list-filter";
import { ProductsFilterValues } from "../../types";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";
import { defaultProductFilterValues } from "../../common";

export type ProductsRootScreenProps = StackScreenProps<
  any,
  "ProductsRootScreen"
>;

export const ProductsRootScreen = ({ navigation }: ProductsRootScreenProps) => {
  const Drawer = createStackHeaderNavigator<ProductsRootScreenParamList>();

  const filterContext = useListFilter<ProductsFilterValues>({
    defaultValues: defaultProductFilterValues,
  });

  return (
    <ListFilterProvider {...filterContext}>
      <ProductFormActionsContext.Provider
        value={{
          onAfterAddProduct: async (product) => {
            navigation.reset({
              index: 0,
              routes: [
                { name: "ProductsListScreen" },
                {
                  name: "EditProductRootScreen",
                  params: { productId: product.id },
                },
              ],
            });
          },
        }}
      >
        <Drawer.Navigator
          screenOptions={{
            animationEnabled: true,
            headerLeft: () => <RootDrawerToggle />,
          }}
        >
          <Drawer.Group>
            <Drawer.Screen
              name="ProductsListScreen"
              component={ProductsListScreen}
              options={{}}
            />
          </Drawer.Group>
          <Drawer.Group
            screenOptions={{
              headerShown: false,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            }}
          >
            <Drawer.Screen
              name="EditProductRootScreen"
              component={EditProductRootScreen}
            />
          </Drawer.Group>
          <Drawer.Group
            screenOptions={{
              headerShown: false,
              presentation: "modal",
            }}
          >
            <Drawer.Screen
              name="CreateProductRootScreen"
              component={CreateProductRootScreen}
            />
            <Drawer.Screen
              name="ProductListFilterRootScreen"
              component={ProductListFilterRootScreen}
            />
          </Drawer.Group>
        </Drawer.Navigator>
      </ProductFormActionsContext.Provider>
    </ListFilterProvider>
  );
};
